import { gql } from "@apollo/client";

const schema = {
  delete: {
    name: "deleteActionNew",
    serviceName: "admin",
    query: gql`
      mutation deleteActionNew($ids: [String]!) {
        deleteActionNew(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
